import React, { useState } from 'react';
import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { DataTable } from '../components/DataTable';
import { KPICard } from '../components/KPICard';
import { ChoroplethMap } from '../components/ChoroplethMap';
import { TabView } from '../components/TabView';
import { mockTrafficData, mockTrafficFines } from '../data/mockData';
const TrafficOffensesReport = () => {
  const [view, setView] = useState('dashboard');
  const topOffenses = mockTrafficData.topOffenses;
  const finesOverTime = mockTrafficData.finesOverTime;
  const paymentStatus = mockTrafficData.paymentStatus;
  const COLORS = ['#10b981', '#f59e0b', '#ef4444'];
  const columns = [{
    header: 'Fine Ref No',
    accessor: 'refNo'
  }, {
    header: 'Offense Description',
    accessor: 'offenseDescription'
  }, {
    header: 'Date',
    accessor: 'date'
  }, {
    header: 'Location',
    accessor: 'location'
  }, {
    header: 'Vehicle Plate No',
    accessor: 'plateNo'
  }, {
    header: 'Fine Amount',
    accessor: 'amount'
  }, {
    header: 'Payment Status',
    accessor: 'status'
  }];
  return <div className="p-6" data-id="element-255">
      <div className="flex justify-between items-center mb-6" data-id="element-256">
        <h1 className="text-2xl font-bold" data-id="element-257">
          Traffic Offenses & Public Safety Report
        </h1>
        <TabView tabs={[{
        id: 'dashboard',
        label: 'Dashboard'
      }, {
        id: 'data',
        label: 'Detailed Data'
      }]} activeTab={view} onChange={setView} data-id="element-258" />
      </div>
      {view === 'dashboard' ? <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-259">
            <KPICard title="Total Offenses" value={mockTrafficData.totalOffenses} change="-5.2%" isPositive={true} icon="alert-triangle" color="red" data-id="element-260" />
            <KPICard title="Total Fines Issued" value={`$${mockTrafficData.totalFines.toLocaleString()}`} change="+3.8%" isPositive={false} icon="dollar-sign" color="blue" data-id="element-261" />
            <KPICard title="Average Fine" value={`$${(mockTrafficData.totalFines / mockTrafficData.totalOffenses).toFixed(2)}`} change="+1.2%" isPositive={false} icon="alert-circle" color="purple" data-id="element-262" />
            <KPICard title="Collection Rate" value={`${mockTrafficData.collectionRate}%`} change="+2.5%" isPositive={true} icon="percent" color="green" data-id="element-263" />
          </div>
          <div className="bg-white p-4 rounded-lg shadow mb-8" data-id="element-264">
            <h2 className="text-lg font-semibold mb-4" data-id="element-265">Offense Hotspots</h2>
            <ChoroplethMap data={mockTrafficData.offenseHotspots} data-id="element-266" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-267">
            <div className="bg-white p-4 rounded-lg shadow" data-id="element-268">
              <h2 className="text-lg font-semibold mb-4" data-id="element-269">
                Top 10 Most Common Offenses
              </h2>
              <ResponsiveContainer width="100%" height={300} data-id="element-270">
                <BarChart data={topOffenses} layout="vertical" data-id="element-271">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-272" />
                  <XAxis type="number" data-id="element-273" />
                  <YAxis type="category" dataKey="offense" width={150} data-id="element-274" />
                  <Tooltip data-id="element-275" />
                  <Legend data-id="element-276" />
                  <Bar dataKey="count" fill="#3b82f6" name="Number of Offenses" data-id="element-277" />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="bg-white p-4 rounded-lg shadow" data-id="element-278">
              <h2 className="text-lg font-semibold mb-4" data-id="element-279">
                Fines Issued Over Time
              </h2>
              <ResponsiveContainer width="100%" height={300} data-id="element-280">
                <LineChart data={finesOverTime} data-id="element-281">
                  <CartesianGrid strokeDasharray="3 3" data-id="element-282" />
                  <XAxis dataKey="month" data-id="element-283" />
                  <YAxis yAxisId="left" tickFormatter={value => `$${(value / 1000000).toFixed(1)}M`} data-id="element-284" />
                  <YAxis yAxisId="right" orientation="right" domain={['auto', 'auto']} data-id="element-285" />
                  <Tooltip formatter={(value, name) => {
                if (name === 'Fine Amount ($)') {
                  return [`$${(Number(value) / 1000000).toFixed(1)}M`, name];
                }
                return [value, name];
              }} data-id="element-286" />
                  <Legend data-id="element-287" />
                  <Line yAxisId="left" type="monotone" dataKey="amount" stroke="#3b82f6" name="Fine Amount ($)" data-id="element-288" />
                  <Line yAxisId="right" type="monotone" dataKey="count" stroke="#ef4444" name="Number of Fines" data-id="element-289" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-290">
            <h2 className="text-lg font-semibold mb-4" data-id="element-291">
              Payment Status of Fines
            </h2>
            <div className="flex flex-col lg:flex-row items-center justify-between gap-8 p-2" data-id="element-292">
              <div className="w-full max-w-[350px] mx-auto" data-id="element-293">
                <ResponsiveContainer width="100%" height={320} data-id="element-294">
                  <PieChart data-id="element-295">
                    <Pie data={paymentStatus} cx="50%" cy="50%" labelLine={false} outerRadius={120} innerRadius={60} fill="#8884d8" dataKey="value" paddingAngle={2} label={({
                  name,
                  percent
                }) => `${name}: ${(percent * 100).toFixed(0)}%`} data-id="element-296">
                      {paymentStatus.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} stroke="#fff" strokeWidth={2} data-id="element-297" />)}
                    </Pie>
                    <Tooltip formatter={value => [`${value.toLocaleString()}`, 'Count']} data-id="element-298" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="bg-gray-50 rounded-lg p-6 shadow-sm w-full max-w-md" data-id="element-299">
                <h3 className="text-base font-medium text-gray-700 mb-4" data-id="element-300">
                  Payment Status Breakdown
                </h3>
                <div className="grid grid-cols-1 gap-4" data-id="element-301">
                  {paymentStatus.map((entry, index) => <div key={index} className="flex items-center" data-id="element-302">
                      <div className="w-5 h-5 mr-3 rounded-sm shadow-sm" style={{
                  backgroundColor: COLORS[index % COLORS.length]
                }} data-id="element-303"></div>
                      <div className="flex flex-col" data-id="element-304">
                        <span className="font-medium" data-id="element-305">{entry.name}</span>
                        <span className="text-sm text-gray-600" data-id="element-306">
                          {entry.value.toLocaleString()} cases (
                          {(entry.value / mockTrafficData.totalOffenses * 100).toFixed(1)}
                          %)
                        </span>
                      </div>
                    </div>)}
                  <div className="mt-2 pt-3 border-t border-gray-200" data-id="element-307">
                    <div className="flex justify-between text-sm font-medium" data-id="element-308">
                      <span data-id="element-309">Total:</span>
                      <span data-id="element-310">
                        {mockTrafficData.totalOffenses.toLocaleString()} cases
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </> : <div className="bg-white p-4 rounded-lg shadow" data-id="element-311">
          <h2 className="text-lg font-semibold mb-4" data-id="element-312">Traffic Fines</h2>
          <DataTable columns={columns} data={mockTrafficFines} pagination searchable exportable data-id="element-313" />
        </div>}
    </div>;
};
export default TrafficOffensesReport;